import {isDev} from 'config';
import HeadNext from 'next/head';
import {FC} from 'react';
import {ISeoMetadata} from 'types';

interface IProps {
  data?: ISeoMetadata;
}

export const SeoMetadata: FC<IProps> = ({data}) => {
  if (isDev)
    return (
      <HeadNext>
        <title>Straus MD Delivery</title>
        <meta name="description" content="stage delivery description" />
      </HeadNext>
    );
  if (!data) return null;
  const dynamicLink = 'straus.mobile://restaurant/' + (data.og_url ? data.og_url.split('/').pop() : '');
  return (
    <HeadNext>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta property="og:type" content={!data.type ? 'website' : 'mobile'} />
      <meta property="og:image" content={data.og_image}></meta>
      <meta property="og:title" content={data.og_title} />
      {data?.og_url && <meta property="og:url" content={data.og_url} />}
      {data?.og_url && <link rel="canonical" href={data.og_url} />}
      {data?.og_url && (
        <link rel="alternate" href={data.og_url.replace('https://straus.md', 'https://straus.md/en')} hrefLang="en" />
      )}
      {data?.og_url && (
        <link rel="alternate" href={data.og_url.replace('https://straus.md', 'https://straus.md/ru')} hrefLang="ru" />
      )}
      {data?.og_url && (
        <link rel="alternate" href={data.og_url.replace('https://straus.md', 'https://straus.md/ro')} hrefLang="ro" />
      )}

      <meta name="google-site-verification" content="BMK33yFIVapcrkdP18CGHMWEdOeea7XQ_mexisoUy1U" />
      {/* shpw app in website */}
      <meta name="apple-itunes-app" content={`app-id=1438722558, app-argument=${data.og_url}`} />
      {/* like tazz */}
      <meta property="al:android:protocol_name" content="straus.mobile" />
      <meta property="al:android:app_name" content="STRAUS" />
      <meta property="al:android:url" content={dynamicLink} />
      <meta property="al:android:package" content="straus.mobile" />
      <meta property="al:android:app_url" content="https://play.google.com/store/apps/details?id=straus.mobile" />

      <meta property="al:ios:protocol_name" content="straus.mobile" />
      <meta property="al:ios:app_name" content="STRAUS" />
      <meta property="al:ios:url" content={dynamicLink} />
      <meta property="al:ios:app_store_id" content="1438722558" />
      <meta property="al:ios:app_url" content="https://apps.apple.com/ro/app/straus.mobile/id1438722558" />
    </HeadNext>
  );
};
